export const productFeatureTokens = {
  colors: {
    background: "#050505",
    surface: "rgba(7, 7, 7, 0.82)",
    surfaceSoft: "rgba(255, 255, 255, 0.07)",
    text: "#ffffff",
    textSoft: "rgba(255, 255, 255, 0.84)",
    textMuted: "rgba(255, 255, 255, 0.64)",
    accent: "#e50914",
    accentDark: "#b80710",
    accentSoft: "rgba(229, 9, 20, 0.16)",
    border: "rgba(255, 255, 255, 0.20)",
    divider: "rgba(255, 255, 255, 0.18)",
    buttonText: "#ffffff",
    imageFallback: "#171717",
    focus: "rgba(229, 9, 20, 0.44)",
    overlayStart: "rgba(0, 0, 0, 0.97)",
    overlayMiddle: "rgba(0, 0, 0, 0.68)",
    overlayEnd: "rgba(0, 0, 0, 0.20)",
    shadow: "0 28px 80px rgba(0, 0, 0, 0.42)",
    productShadow: "0 28px 64px rgba(0, 0, 0, 0.46)",
  },
  radius: {
    frame: 8,
    button: 6,
    media: 6,
    icon: 999,
  },
  spacing: {
    shellY: 42,
    shellX: 24,
    tabletShellY: 32,
    tabletShellX: 20,
    mobileShellY: 22,
    mobileShellX: 12,
    framePaddingY: 64,
    framePaddingX: 64,
    tabletFramePaddingY: 44,
    tabletFramePaddingX: 34,
    mobileFramePaddingY: 28,
    mobileFramePaddingX: 18,
    copyGap: 22,
    featureGap: 18,
    actionGap: 18,
  },
  sizes: {
    maxWidth: 1420,
    minHeight: 640,
    tabletMinHeight: 600,
    mobileMinHeight: 760,
    mediaMinHeight: 520,
    tabletMediaMinHeight: 420,
    mobileMediaMinHeight: 310,
    productMaxWidth: 520,
    tabletProductMaxWidth: 440,
    mobileProductMaxWidth: 330,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    eyebrow: {
      fontSize: 18,
      mobileFontSize: 13,
      lineHeight: 1,
      fontWeight: 900,
      letterSpacing: 0,
      textTransform: "uppercase" as const,
    },
    title: {
      fontSize: 70,
      tabletFontSize: 54,
      mobileFontSize: 38,
      lineHeight: 0.98,
      mobileLineHeight: 1.05,
      fontWeight: 950,
      letterSpacing: 0,
    },
    subtitle: {
      fontSize: 28,
      tabletFontSize: 24,
      mobileFontSize: 19,
      lineHeight: 1.12,
      fontWeight: 900,
      letterSpacing: 0,
      textTransform: "uppercase" as const,
    },
    description: {
      fontSize: 20,
      tabletFontSize: 18,
      mobileFontSize: 16,
      lineHeight: 1.46,
      fontWeight: 500,
      letterSpacing: 0,
    },
    feature: {
      fontSize: 14,
      mobileFontSize: 12,
      lineHeight: 1.28,
      fontWeight: 800,
      letterSpacing: 0,
    },
    cta: {
      fontSize: 18,
      mobileFontSize: 15,
      lineHeight: 1,
      fontWeight: 900,
      letterSpacing: 0,
      textTransform: "uppercase" as const,
    },
    secondaryCta: {
      fontSize: 17,
      mobileFontSize: 14,
      lineHeight: 1,
      fontWeight: 800,
      letterSpacing: 0,
    },
    footnote: {
      fontSize: 15,
      mobileFontSize: 12,
      lineHeight: 1.3,
      fontWeight: 500,
      letterSpacing: 0,
    },
  },
  icons: {
    primaryAction: "shoppingCart",
    secondaryAction: "arrowRight",
    imageLink: "externalLink",
    footnote: "lock",
    featureOne: "user",
    featureTwo: "alertTriangle",
    featureThree: "clipboardCheck",
  },
  defaults: {
    imageOpenInNewTab: true,
    backgroundObjectPosition: "center",
    backgroundMobileObjectPosition: "68% center",
    productObjectPosition: "center",
  },
} as const;

export type ProductFeatureColorToken = keyof typeof productFeatureTokens.colors;
export type ProductFeatureIconSlot = keyof typeof productFeatureTokens.icons;
